<template>
    <ai-subtitle value="Данные по ЕГРЮЛ" />
</template>

<script setup>
// import { inject } from 'vue';
import AiSubtitle from '@/components/ai-subtitle.vue';

// const data = inject('serverData');
</script>
